module.exports = __webpack_public_path__ + "img/img33.99ab201f.svg";